import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import CaseForChange from './pages/CaseForChange';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Attributions from './pages/Attributions';
import StrategicCommentary from './pages/StrategicCommentary';
import CommentaryPost from './pages/CommentaryPost';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/case-for-change" element={<CaseForChange />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/attributions" element={<Attributions />} />
            <Route path="/strategic-commentary" element={<StrategicCommentary />} />
            <Route path="/strategic-commentary/:slug" element={<CommentaryPost />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;